module.exports = __webpack_public_path__ + "img/jshuaiku.f5454254.gif";